import React, { PureComponent } from 'react'
import { TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { hasAccess } from '../../utils/api'

import { EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

export default class TookanEmployeeInfoItem extends PureComponent {
  state = {
    isNew: true,
  }

  extractShopAndTeam = (value) => {
    const splittedValue = value.split('BLAZE')

    const shopId = splittedValue[0]
    const teamId = splittedValue[1]

    return {
      shopId,
      teamId,
    }
  }

  linkTeam = (e) => {
    const { data = [] } = this.props

    const { isNew } = this.state

    const { value = '' } = e.target

    const { shopId, teamId } = this.extractShopAndTeam(value)

    this.props.linkItem(data.id, shopId, teamId, isNew, () => this.props.disableEdit())
  }

  removeWorker = () => {
    const { data = {} } = this.props

    const { employeeOnFleetInfoResults = [], id } = data

    const { selectedOnfleet } = this.filterSelectedTeam(employeeOnFleetInfoResults)

    const { shopId, teamId } = this.extractShopAndTeam(selectedOnfleet.value)

    this.props.removeWorker(id, shopId, teamId, () => this.props.disableEdit())
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  filterSelectedTeam = (tookanInfoList) => {
    const tookanEmployeeTeam = tookanInfoList || []

    const { shopsList = {}, tookanTeamList = [] } = this.props

    const { values = [] } = shopsList

    let selectedTeam = []
    let selectedTookan = {}

    tookanEmployeeTeam.forEach((team) => {
      const shop =
        (values &&
          values.find((shop) => {
            return shop.id === team.shopId
          })) ||
        {}

      if (team.tookanAgentId) {
        if (this.state.isNew) {
          this.setState({
            isNew: false,
          })
        }

        selectedTeam.push(shop.name + ':' + team.tookanAgentId)
      }

      const seletedTeamListItem = tookanTeamList.find((teamListItem) => {
        return team.shopId === teamListItem.shopId
      })

      const selectedTeamInfo =
        seletedTeamListItem &&
        seletedTeamListItem.tookanTeamInfo.find((teamInfo) => {
          return teamInfo.team_id === team.teamId
        })

      if (selectedTeamInfo) {
        selectedTookan = {
          value: `${team.shopId}BLAZE${selectedTeamInfo.id}`,
          label: `${(shop && shop.name) || ''} | ${selectedTeamInfo.team_name}`,
        }
      }
    })

    return {
      selectedTeam,
      selectedTookan,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { data } = nextProps

    if ((!data.tookanInfoList || !data.tookanInfoList.length) && !prevState.isNew) {
      return {
        isNew: true,
      }
    }

    return null
  }

  render() {
    const { data, editMode, teamList } = this.props

    const { tookanInfoList = [] } = data

    const { selectedTeam, selectedTookan } = this.filterSelectedTeam(tookanInfoList)

    const { isNew } = this.state

    //const showRemoveButton = editMode && !isNew

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">{`${data.firstName} ${data.lastName}`}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={selectedTookan.value}
            onChange={this.linkTeam}
            valueToRender={selectedTookan.label}
            editMode={editMode}
          >
            {teamList.map((item, index) => {
              return (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">{selectedTeam.join()}</TableCell>
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
              editTitle={isNew ? 'Link' : 'Update'}
              hideSave
            />
            {/* showRemoveButton ? <Button className="danger-button" onClick={this.removeWorker}>Remove Team</Button> : null */}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Tookan/TookanEmployeeInfoItem.js